import { render, staticRenderFns } from "./CallPage.vue?vue&type=template&id=02de54dc&scoped=true&"
import script from "./CallPage.vue?vue&type=script&lang=js&"
export * from "./CallPage.vue?vue&type=script&lang=js&"
import style0 from "./CallPage.vue?vue&type=style&index=0&id=02de54dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02de54dc",
  null
  
)

export default component.exports